import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function PostOpRehab() {
  useEffect(() => {
    document.title =
      "Post-Operative Rehabilitation Protocols | Viksha Health Care";
    const newMetaDescription =
      "Post-operative rehabilitation protocols at Viksha Health Care. Learn the key phases of recovery after orthopaedic surgery and how rehab supports healing.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        Post-Operative Rehabilitation Protocols
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/postOpRehab.avif" />
        </div>
        <div className="textareaofser">
          <h1>Post-Operative Rehabilitation Protocols</h1>

          <p>
            Post-operative rehabilitation is an essential part of recovery after
            orthopaedic surgery. A structured rehabilitation plan helps restore
            strength, flexibility, and joint function while ensuring safe and
            steady healing.
          </p>

          <p>
            Rehabilitation protocols are tailored based on the type of surgery,
            the joint involved, and individual patient needs. The aim is to
            support recovery, reduce pain, and help patients return to daily
            activities with confidence.
          </p>

          <h5>Goals of Post-Operative Rehabilitation</h5>
          <ul>
            <li>Promote safe healing of tissues</li>
            <li>Reduce pain and swelling</li>
            <li>Restore joint mobility and flexibility</li>
            <li>Rebuild muscle strength</li>
            <li>Improve balance and coordination</li>
            <li>Help patients regain independence in daily tasks</li>
          </ul>

          <h5>Phases of Rehabilitation</h5>

          <h6>Early Phase</h6>
          <p>
            The initial phase focuses on gentle movements, pain control, and
            protecting the surgical area. Basic exercises may begin under
            guidance to prevent stiffness and improve circulation.
          </p>

          <h6>Intermediate Phase</h6>
          <p>
            As healing progresses, strengthening and mobility exercises are
            introduced to improve joint stability and muscle function. Activity
            levels are increased gradually while monitoring for discomfort.
          </p>

          <h6>Advanced Phase</h6>
          <p>
            Later stages involve more active exercises and functional training
            to help patients return to normal daily activities, work demands,
            and recreational activities safely.
          </p>

          <h5>Role of Physiotherapy</h5>
          <p>
            Physiotherapy plays a key role in guiding recovery. Therapists
            monitor progress, adjust exercises, and ensure that rehabilitation
            is done safely and effectively according to healing timelines.
          </p>

          <h5>Home Care and Exercise</h5>
          <p>
            Patients are often given home exercise programs to continue recovery
            between therapy sessions. Following these exercises regularly helps
            maintain progress, improve strength, and speed up healing.
          </p>

          <h5>Pain and Swelling Management</h5>
          <p>
            Ice application, limb elevation, and prescribed medications may be
            used to manage pain and swelling in the early stages. Proper rest
            and avoiding overexertion are equally important.
          </p>

          <h5>Gradual Return to Activities</h5>
          <p>
            Activities such as walking, climbing stairs, driving, or returning
            to work are reintroduced gradually based on recovery milestones and
            medical advice. Rushing recovery can increase the risk of
            complications.
          </p>

          <h5>Importance of Following Medical Advice</h5>
          <p>
            Every surgery has a specific healing timeline. Following
            weight-bearing restrictions, using assistive devices when advised,
            and attending scheduled follow-ups are crucial for successful
            recovery.
          </p>

          <h5>Signs to Watch For</h5>
          <ul>
            <li>Increasing pain or swelling</li>
            <li>Redness or warmth around the surgical area</li>
            <li>Reduced movement compared to previous sessions</li>
            <li>Unusual discomfort during exercises</li>
            <li>Fever or wound-related concerns</li>
          </ul>

          <p>
            Following post-operative rehabilitation protocols carefully can lead
            to better surgical outcomes, improved mobility, and a quicker return
            to an active and independent lifestyle.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(PostOpRehab);
